import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicStylesDirective } from './dynamic-styles.directive';



@NgModule({
  declarations: [
    DynamicStylesDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DynamicStylesDirective
  ]
})
export class DirectivesModule { }
